import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { setFilterModeToAll, setFilterModeToReal, setFilterModeToDemo } from './../actions/actions';

class FilterMode extends Component {
  render() {
    return (
      <div className="filter-mode">
        <label className="filter-mode__title">Filter</label>
        <Button className={`filter-mode__real ${this.props.filterMode === 'real' ? 'btn-info': ''}`} onClick={this.props.setFilterModeToReal}>Real</Button>
        <Button className={`filter-mode__demo ${this.props.filterMode === 'demo' ? 'btn-info': ''}`} onClick={this.props.setFilterModeToDemo}>Demo</Button>
        <Button className={`filter-mode__all ${this.props.filterMode === 'all' ? 'btn-info': ''}`} onClick={this.props.setFilterModeToAll}>All</Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentState = state.environment_information;
  const filterMode = currentState.get('filterMode')

  return {
    filterMode
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setFilterModeToAll: () => dispatch(setFilterModeToAll()),
    setFilterModeToReal: () => dispatch(setFilterModeToReal()),
    setFilterModeToDemo: () => dispatch(setFilterModeToDemo())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterMode);


// WEBPACK FOOTER //
// ./src/components/FilterMode.js